/**
 * PhotoSwipe lightbox for metaobject gallery carousels (see sections/metaobject-gallery-carousel.liquid).
 * Depends on photoswipe.umd.min.js + photoswipe-lightbox.umd.min.js (defer, same order before this file).
 */
(function () {
  function destroyGallery(root) {
    if (root._pswpLightbox && typeof root._pswpLightbox.destroy === 'function') {
      root._pswpLightbox.destroy();
    }
    root._pswpLightbox = null;
    root.removeAttribute('data-pswp-ready');
  }

  function initGalleries(scope) {
    if (typeof PhotoSwipeLightbox === 'undefined' || typeof PhotoSwipe === 'undefined') {
      return;
    }

    var roots = scope
      ? scope.querySelectorAll('[data-metaobject-gallery]')
      : document.querySelectorAll('[data-metaobject-gallery]');

    roots.forEach(function (root) {
      var galleryEl = root.querySelector('[data-pswp-gallery]');
      if (!galleryEl || !galleryEl.querySelector('a[data-pswp-trigger]')) {
        return;
      }

      destroyGallery(root);

      var lightbox = new PhotoSwipeLightbox({
        gallery: galleryEl,
        children: 'a[data-pswp-trigger]',
        pswpModule: PhotoSwipe,
      });

      lightbox.on('uiRegister', function () {
        if (!lightbox.pswp || !lightbox.pswp.ui) return;

        lightbox.pswp.ui.registerElement({
          name: 'custom-caption',
          order: 9,
          isButton: false,
          appendTo: 'root',
          html: '',
          className: 'pswp__custom-caption metaobject-gallery-pswp-caption',
          onInit: function (el, pswp) {
            function updateCaption() {
              var captionHTML = '';
              var slide = pswp.currSlide;
              if (slide && slide.data && slide.data.element) {
                var hiddenCaption = slide.data.element.querySelector('.hidden-caption-content');
                if (hiddenCaption) {
                  captionHTML = hiddenCaption.innerHTML;
                } else {
                  var img = slide.data.element.querySelector('img');
                  if (img) captionHTML = img.getAttribute('alt') || '';
                }
              }
              el.innerHTML = captionHTML || '';
              el.hidden = !captionHTML;
            }

            pswp.on('change', updateCaption);
            updateCaption();
          },
        });
      });

      lightbox.init();
      root._pswpLightbox = lightbox;
      root.setAttribute('data-pswp-ready', '');
    });
  }

  function onReady() {
    initGalleries(null);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector && event.target.querySelector('[data-metaobject-gallery]')) {
      initGalleries(event.target);
    }
  });
})();
